<template>
  <a-date-picker
    v-model:value="value"
    @change="selectTime"
    :disabled-date="disabledDate"
    :size="pageType"
  />
</template>

<script >
import { defineComponent, ref, watch, computed } from "vue";
import moment, { Moment } from "moment";

export default defineComponent({
  props: {
    defaultVal: String,
  },
  setup(props, context) {
    const disabledDate = (current) => {
      return current && current > moment().endOf("day");
    };

    const value = ref();

    watch(
      () => props.defaultVal,
      (val) => {
        if (val === undefined || val === null || val === "") {
          value.value = null;
        } else if (typeof val === "string") {
          value.value = moment(val);
        }
      },
      { immediate: true, deep: true }
    );

    const selectTime = (e) => {
      let day;
      if (e === null) {
        day = undefined;
      } else if (e.format) {
        day = e.format("YYYY-MM-DD");
        // eslint-disable-next-line no-useless-escape
        // day = day.replace(/\-/g, "/");
      }
      context.emit("userDelectDay", day);
    };

    return {
      value,
      selectTime,
      disabledDate,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
